import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Async from './Async';
import PrivateRoutes from '@templates/PrivateRoutes/PrivateRoutes';
import publicOptions from './publicOptions';
import TemplateAccount from '../templates/Account/Account';

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/account">
          <TemplateAccount>
            {publicOptions.map(({ screenName, pathname, ...props }) => (
              <Route
                key={screenName}
                path={pathname}
                component={Async[screenName]}
                {...props}
              />
            ))}
          </TemplateAccount>
        </Route>
        <PrivateRoutes>
          {privateOptions =>
            privateOptions.map(({ screenName, pathname, ...props }) => (
              <Route
                key={pathname}
                path={pathname}
                component={Async[screenName]}
                {...props}
              />
            ))
          }
        </PrivateRoutes>
      </Switch>
    </BrowserRouter>
  );
}

export default React.memo(Routes);
